import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
} from "@angular/core";

import {
    ProductEnvironmentOperationAttribute,
    ProductEnvironmentOperationData,
} from "@hermes/api-model-product-environment";

@Component({
    selector: "h-traceability-attribute",
    templateUrl: "./traceability-attribute.component.html",
    styleUrls: ["./traceability-attribute.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TraceabilityAttributeComponent implements OnChanges {
    @Input({ required: true })
    public traceabilityAttributes!: ProductEnvironmentOperationAttribute[];
    @Input({ required: true })
    public hasRecyclability = false;
    public traceabilityTexts?: string[];
    public orTranslationText = $localize`:@@hermes-global-translations.or:Or`;

    public ngOnChanges(changes: SimpleChanges) {
        if (
            changes.traceabilityAttributes &&
            changes.traceabilityAttributes.currentValue
        ) {
            this.traceabilityTexts = this.traceabilityAttributes
                ?.map((attribute) =>
                    this.getProductTraceabilityAttributeText(attribute),
                )
                .filter(Boolean);
        }
    }

    public getProductTraceabilityAttributeText(
        attribute: ProductEnvironmentOperationAttribute,
    ): string {
        return `${attribute.value} : ${
            attribute.data
                ? this.getAttributeDataText(attribute.data)
                : undefined
        }`;
    }

    public getAttributeDataText(
        datas: ProductEnvironmentOperationData[],
    ): string {
        let text = "";
        datas.forEach((data, index) => {
            text += `${data.value}${
                index < datas.length - 1 ? ` ${this.orTranslationText} ` : ""
            }`;
        });
        return text;
    }
}
